import React, { useEffect, useState } from "react";
import { Autocomplete, GridLegacy } from "@mui/material";
import TextField from "@mui/material/TextField";

const SelectWorkPlaceModal = (props: any) => {
  // const [workspace, setWorkSpace] = useState(props.data);
  const [value, setValue] = React.useState<any>("");
  const [inputValue, setInputValue] = React.useState("");
  // const [open, setOpen] = useState(false);
  const [load, setLoad] = useState(true);
  const [LastDrx, setLastDrx] = useState("");

  useEffect(() => {
    setLoad(true);
    if (props.drx === LastDrx) {
    } else {
      setValue("");
      setLastDrx(props.drx);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.drx]);

  const ClickField = () => {
    if (props.drx !== undefined) {
      setLoad(false);
    }
  };

  //   const OnKeyEnter=(e:any)=>{
  //     if(e.keyCode === 13 && open ===false) {
  //       props.KeyDown(e);
  //     }else if(e.keyCode === 40 && open ===false) {
  //     //   getDrx();
  //     }
  //   }

  function MenuItems(WPList: any) {
    let array: never[] = [],
      val: any;

    for (const value of Object.values(WPList)) {
      val = value;
      if (val.Name === props.drx) {
        props.setServer(val.Server);
        return val.WorkPlace;
      }
    }
    return array;
  }

  return (
    <GridLegacy item xs>
      <Autocomplete
        selectOnFocus
        loadingText={"Выберите рабочее место"}
        fullWidth
        value={value}
        onChange={(event: any, newValue: string | null) => {
          setValue(newValue);
        }}
        inputValue={inputValue}
        onInputChange={(event: any, newInputValue: React.SetStateAction<string>) => {
          props.setBackInfo(newInputValue);
          setInputValue(newInputValue);
        }}
        id="workplace"
        options={MenuItems(props.json)}
        // onKeyDown={OnKeyEnter}
        renderInput={(params) => <TextField onClick={ClickField} {...params} label="Рабочее место" />}
      />
    </GridLegacy>
  );
};

export default SelectWorkPlaceModal;
